<template>
  <div class="wrapper log-bg">
    <div class="header-area bg-transparent border-0">
      <div class="container-fluid">
        <div class="row">
          <div class="col-6">
            <router-link :to="{ name: 'Login' }">
              <span class="back-arrow mt-4"></span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="body-area pb-0">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="text-center pb-5">
              <img src="/static/img/logo.png" alt />
            </div>
          </div>
          <div class="col-12 mt-5">
            <input v-model="email" type="text" class="form-input" placeholder="E-posta adresin" />
          </div>
          <div class="col-12">
            <button class="confirm-button" @click="send">Hatırlat</button>
          </div>

          <div class="col-12" style="margin-top: 20px; text-align: center">
            <a
              href="javascript:;"
              @click="$router.push({name: 'ChangePassword'})"
            >Sıfırlama kodunuz varsa buraya tıklayın</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Menu from "@/components/Menu";
import axios from "axios";
export default {
  name: "ForgotPassword",
  components: {
    Footer,
    Menu,
    Header
  },
  data() {
    return {
      email: null
    };
  },
  methods: {
    send() {
      var data = new FormData();
      data.append("email", this.email);
      axios.post("uyelik/sifremi-unuttum", data).then(res => {
        if (res.data.error) {
          this.$notify({
            title: "Hata",
            message: res.data.error,
            type: "error"
          });
        } else {
          this.$notify({
            title: "Hata",
            message: res.data.message,
            type: "success"
          });
        }
      });
    }
  },
  beforeMount() {
    if (this.$route.query.email != null) {
      this.$router.replace({
        name: "ChangePassword",
        params: this.$route.query,
        query: this.$route.query
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/ForgotPassword.vue